import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { gotoUrl } from "@menu/core/lib";

const InboxIcon = observer((props: ContextProps) => {
    const { inbox } = props.context;
    const { display, url, unread } = inbox;

    if (!display) {
        return null;
    }

    return (<span className="inbox-icon">
        <i className="icon-imi-inbox"
            onClick={() => gotoUrl(url)} />
        {unread > 0 && <i className="unread-count">{unread}</i>}
    </span>);
});

export default InboxIcon;